export default {
  title: "Менеджерлер",
  newPassRules1: "Кеминде 8 белгиден турушу керек",
  appearAfterCreateManager: "Бул жерде менеджер түзүлгөндөн кийин пайда болот",
  canCreateManagerAfterConfirmEntity:
    "Менеджерлерди түзүү мүмкүнчүлүгү сиздин юридикалык жак модерациядан өткөндөн кийин жеткиликтүү болот",
  managerPassReset: "Менеджердин сырсөзү кайра коюлду",
  writeDownLoginAndPass:
    "Көңүл буруңуз! Кирүү үчүн логин жана сырсөздү жазып алыңыз. Биринчи кирүүдө менеджер жаңы сырсөз түзүшү керек болот.",
  oneTimePass: "Бир жолку сырсөз",
  loginAndPassCopied: "Логин жана сырсөз көчүрмөгө сакталды",
  managerCreated: "Менеджер түзүлдү!",
  copyLoginAndPass: "Логин жана сырсөздү көчүрүү",
  sureToDeleteManager: "Менеджерди өчүргүңүз келгенине ишенесизби?",
  editingManager: "Менеджерди түзөтүү",
  creatingManager: "Менеджерди түзүү",
  resetPassword: "Сырсөздү кайра коюу",
  workPost: "Кызмат орду",
  accessToCabinetPages: "Кабинет беттерине кирүү мүмкүнчүлүгү",
  deleteChanges: "Киргизилген өзгөртүүлөрдү өчүрөсүзбү?",
  cancelManagerCreating: "Менеджер түзүүнү жокко чыгарасызбы?",
  ifNeedSaveGoBack:
    "Эгер сактагыңыз келсе, артка кайтыңыз. Болбосо, бардык өзгөртүүлөр сакталбайт.",
  enteredInfoDontSave:
    "Киргизилген маалымат сакталбайт. Түзөтүүгө кайтуу үчүн «Артка» баскычын басыңыз.",
  notLess8Chars: "Кеминде 8 белги",
  requiredField: "Милдеттүү талаа",
};
